module.exports = __webpack_public_path__ + "static/media/testkit2.6d02fab8.jpg";